(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paired-product"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll("[data-paired-block]").forEach(function (container) {
    var dataEl = container.querySelector(".paired-product__data");
    if (!dataEl) return;
    var pairedData = {};
    try { pairedData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var inner = container.querySelector(".paired-product__inner");
    var linkEl = container.querySelector("[data-paired-url]");
    var titleEl = container.querySelector("[data-paired-title]");
    var colourEl = container.querySelector("[data-paired-colour]");
    var priceEl = container.querySelector("[data-paired-price]");
    var imageWrap = container.querySelector("[data-paired-image]");
    var LENGTH_SUFFIXES = ["short", "regular", "tall", "petite", "long", "plus"];
    function stripSuffix(title) {
      if (!title) return title;
      var parts = title.split(" ");
      if (parts.length > 1 && LENGTH_SUFFIXES.indexOf(parts[parts.length - 1].toLowerCase()) !== -1) {
        return parts.slice(0, -1).join(" ");
      }
      return title;
    }
    function updatePaired(variantId) {
      if (!variantId) return;
      var paired = pairedData[String(variantId)];
      if (!paired) { inner.hidden = true; return; }
      inner.hidden = false;
      if (linkEl) linkEl.href = paired.url;
      if (titleEl) titleEl.textContent = stripSuffix(paired.title);
      if (colourEl) colourEl.textContent = paired.colour || "";
      if (priceEl) priceEl.textContent = paired.price || "";
      if (imageWrap && paired.image) {
        var img = imageWrap.querySelector("img");
        if (img) { img.src = paired.image; img.alt = paired.image_alt || paired.title; img.srcset = ""; img.sizes = ""; }
        else { imageWrap.innerHTML = ""; var newImg = document.createElement("img"); newImg.className = "paired-product__img"; newImg.src = paired.image; newImg.alt = paired.image_alt || paired.title; imageWrap.appendChild(newImg); }
      }
    }
    function getVariantFromForm() {
      var form = document.querySelector("form[action*='/cart/add']");
      return form ? (form.querySelector("input[name='id']") || {}).value : null;
    }
    document.addEventListener("variant:change", function (e) {
      var id = e.detail && (e.detail.variant ? e.detail.variant.id : e.detail.id);
      if (id) updatePaired(id);
    });
    document.addEventListener("change", function (e) {
      var form = e.target && e.target.closest && e.target.closest("form[action*='/cart/add']");
      if (form) { var v = getVariantFromForm(); if (v) updatePaired(v); }
    });
    window.addEventListener("popstate", function () {
      var v = getVariantFromForm() || new URLSearchParams(window.location.search).get("variant");
      if (v) updatePaired(v);
    });
    document.addEventListener("np:gallery-replaced", function () {
      setTimeout(function () {
        var v = getVariantFromForm();
        if (v) updatePaired(v);
      }, 0);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
